export default {
    manufacturerId: "Manufacturer Id",
    companyId: "Company Id",
    manufacturerName: "Manufacturer",
    deviceCategory: "Device Category",
    promilesOdometerCalculated: "Promiles Odometer Calculated",
    simProviderAccountId: "SIM Provider Account Id",
    deviceModelId: "Device Model Id",
    esn: "ESN",
    jbus: "Jbus",
    vbus: "Vbus",
    label: "Label",
    reference: "Reference",
    iccid: "Iccid",
    promiles: "Promiles",
    imei: "IMEI",
    msisdn: "MSISDN",
    data_details_title: "Data Details",
    useEcuVin: "Use Ecu Vin",
    driverBehavior: "Driver Behavior",
    apu: "Apu",
    linkedMode: "Paired Mode",
    hybrid: "Hybrid",
    useEcuOdometer: "Use Ecu Odometer",
    hoursEnable: "Hours Enable",
    pressurePro: "Pressure Pro",
    obd2Alerts: "Obd2 Alerts",
    useEcuEngineHours: "Use Ecu Engine Hours",
    analytic: "Analytic",
    odometerEnable: "Odometer Enable",
    product: "Product",
    output: "Output",
    input: "Input",
    ttu: "Ttu",
    ota: "Ota",
    sms: "Sms",
    comData: "ComData",
    battery: "Battery",
    show: "Show",
    tow: "Tow",
    starter: "Starter",
    motion: "Motion",
    analytics: "Analytics",
    geofence: "Geofence",
    timezoneId: "Timezone Id",
    customRoleId: "Custom Role Id",
    cognitoAuth: "Cognito Auth",
    devicesCount: "Devices Count",
    hasPromiles: "Has Promiles",
    promilesLogin: "Promiles Username",
    promilesEmail: "Promiles Email",
    fuelCardCompanyCode: "Fuel Card Company Code",
    brand: "Brand",
    dealerId: "Brand Id",
    sm: "SM",
    email: "Email",
    euiccid: "EUICCID",
    deviceID: "Device Id",
    modemID: "Modem Id",
    endConsumerId: "End Consumer Id",
    requestAccepted: "Request Accepted",
    cmdID: "Cmd ID",


    //Sync Zonar
    processed: "Processed",
    entityName: "Type",
    entityIds: "To Process",


    assetSubtypes: "Asset Subtypes",
    account: "Account",
    units: "Units",
    drivers: "Drivers",
    subUsers: "Sub Users",
    assets: "Assets"
};
